import { render, staticRenderFns } from "./FinanceSalesReportHistoricalPage.vue?vue&type=template&id=6bc9a7be&"
import script from "./FinanceSalesReportHistoricalPage.vue?vue&type=script&lang=js&"
export * from "./FinanceSalesReportHistoricalPage.vue?vue&type=script&lang=js&"
import style0 from "./FinanceSalesReportHistoricalPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports